import axios from "axios";
// let api = "http://192.168.5.9:8961/api";
// const img_url = "https://jcgk2025.oss-cn-heyuan.aliyuncs.com/";
// let api = "http://houtai.jiechengk.cn/api";
let api = "https://xcx.jiechengk.cn/api";
const img_url = "https://jcgk2025.oss-cn-heyuan.aliyuncs.com/";
export { api, img_url };

export const login = params => {
  return axios.post(`${api}/login/accountLogin`, params).then(res => res.data);
};
//用户列表
export const usergetList = params => {
  return axios.post(`${api}/user/getList`, params).then(res => res.data);
};
//用户分页列表
export const usergetMePage = params => {
  return axios.post(`${api}/user/getMePage`, params).then(res => res.data);
};

//用户设置
export const useredit = params => {
  return axios.post(`${api}/user/edit`, params).then(res => res.data);
};
//用户删除
export const userremove = params => {
  return axios
    .get(`${api}/user/remove/` + params.params.id, params)
    .then(res => res.data);
};
// 用户统计
export const getUserCount = params => {
  return axios
    .get(`${api}/statistic/user/getUserCount`, params)
    .then(res => res.data);
};

// ==================== 管理员模块 ====================
// 添加用户
export const addAccount = params => {
  return axios.post(`${api}/AccountEntity/addAccount`, params).then(res => res.data);
};
// 后台管理账号绑定老师或学校记录接口
export const bindUserType = params => {
  return axios.post(`${api}/AccountEntity/bindUserType`, params).then(res => res.data);
};
// 修改账号
export const editAccount = params => {
  return axios.post(`${api}/AccountEntity/edit`, params).then(res => res.data);
};
// 获取账号详情
export const getAccountDetail = params => {
  return axios.get(`${api}/AccountEntity/getDetail/` + params.params.id).then(res => res.data);
};
// 获取账号列表
export const getAccountList = params => {
  return axios.post(`${api}/AccountEntity/getList`, params).then(res => res.data);
};
// 获取账号分页列表
export const getAccountMePage = params => {
  return axios.post(`${api}/AccountEntity/getMePage`, params).then(res => res.data);
};
// 删除账号
export const removeAccount = params => {
  return axios.get(`${api}/AccountEntity/remove/` + params.params.id).then(res => res.data);
};

// ==================== 合同文件模块 ====================
// 新增/保存合同文件
export const editContractFile = params => {
  return axios.post(`${api}/contractfile/edit`, params).then(res => res.data);
};
// 获取合同文件详情
export const getContractFileDetail = params => {
  return axios.get(`${api}/contractfile/getDetail/` + params.params.id).then(res => res.data);
};
// 获取合同文件列表
export const getContractFileList = params => {
  return axios.post(`${api}/contractfile/getList`, params).then(res => res.data);
};
// 获取合同文件分页列表
export const getContractFileMePage = params => {
  return axios.post(`${api}/contractfile/getMePage`, params).then(res => res.data);
};
// 删除合同文件
export const removeContractFile = params => {
  return axios.get(`${api}/contractfile/remove/` + params.params.id).then(res => res.data);
};

// ==================== 客户管理模块 ====================
// 新增/保存客户
export const editCustomer = params => {
  return axios.post(`${api}/customer/edit`, params).then(res => res.data);
};
// 获取客户详情
export const getCustomerDetail = params => {
  return axios.get(`${api}/customer/getDetail/` + params.params.id).then(res => res.data);
};
// 获取客户列表
export const getCustomerList = params => {
  return axios.post(`${api}/customer/getList`, params).then(res => res.data);
};
// 获取客户分页列表
export const getCustomerMePage = params => {
  return axios.post(`${api}/customer/getMePage`, params).then(res => res.data);
};
// 删除客户
export const removeCustomer = params => {
  return axios.get(`${api}/customer/remove/` + params.params.id).then(res => res.data);
};

// ==================== 文件上传模块 ====================
// 文件上传
export const uploadFile = (businessType, params) => {
  return axios.post(`${api}/file/upload/${businessType}`, params).then(res => res.data);
};

// ==================== 图形验证码模块 ====================
// 获取验证码
export const getKaptchaCode = () => {
  return axios.get(`${api}/kaptcha/getCode`).then(res => res.data);
};
// 根据UUID获取验证码
export const getKaptchaCodeByUUID = params => {
  return axios.get(`${api}/kaptcha/getCodeByUUID`, params).then(res => res.data);
};

// ==================== 登录注册模块 ====================
// 账号登录 (已存在，保持原有)
// export const login = params => {
//   return axios.post(`${api}/login/accountLogin`, params).then(res => res.data);
// };
// 冻结账号
export const freezeAccount = params => {
  return axios.post(`${api}/login/freeze`, params).then(res => res.data);
};
// 用户登录
export const userLogin = params => {
  return axios.post(`${api}/login/login`, params).then(res => res.data);
};
// 微信登录
export const loginByMawx = params => {
  return axios.post(`${api}/login/loginByMawx`, params).then(res => res.data);
};
// 退出登录
export const logout = () => {
  return axios.post(`${api}/login/logout`).then(res => res.data);
};

// ==================== 订单模块 ====================
// 取消支付
export const cancelOrderPay = id => {
  return axios.get(`${api}/orderEntity/canclePay/${id}`).then(res => res.data);
};
// 获取订单列表
export const getOrderList = params => {
  return axios.post(`${api}/orderEntity/getList`, params).then(res => res.data);
};
// 获取订单分页列表
export const getOrderMePage = params => {
  return axios.post(`${api}/orderEntity/getMePage`, params).then(res => res.data);
};
// 发送订单
export const sendOrder = params => {
  return axios.post(`${api}/orderEntity/sendOrder`, params).then(res => res.data);
};
// 结算订单
export const settleOrder = params => {
  return axios.post(`${api}/orderEntity/settle`, params).then(res => res.data);
};

// ==================== 支付记录模块 ====================
// 确认支付
export const confirmPay = params => {
  return axios.post(`${api}/payRecord/confirmPay`, params).then(res => res.data);
};
// 新增/保存支付记录
export const editPayRecord = params => {
  return axios.post(`${api}/payRecord/edit`, params).then(res => res.data);
};
// 批量新增/保存支付记录
export const editPayRecords = params => {
  return axios.post(`${api}/payRecord/edits`, params).then(res => res.data);
};
// 获取支付记录详情
export const getPayRecordDetail = params => {
  return axios.get(`${api}/payRecord/getDetail/` + params.params.id).then(res => res.data);
};
// 获取支付记录列表
export const getPayRecordList = params => {
  return axios.post(`${api}/payRecord/getList`, params).then(res => res.data);
};
// 获取支付记录分页列表
export const getPayRecordMePage = params => {
  return axios.post(`${api}/payRecord/getMePage`, params).then(res => res.data);
};
// 汇付通知
export const hfNotify = params => {
  return axios.post(`${api}/payRecord/hfNotify`, params).then(res => res.data);
};
// 汇付退款通知
export const hfRefundNotify = params => {
  return axios.post(`${api}/payRecord/hfRefundNotify`, params).then(res => res.data);
};
// 删除支付记录
export const removePayRecord = params => {
  return axios.post(`${api}/payRecord/remove`, params).then(res => res.data);
};
// 批量删除支付记录
export const removePayRecords = params => {
  return axios.post(`${api}/payRecord/removes`, params).then(res => res.data);
};
// 微信通知
export const wxNotify = params => {
  return axios.post(`${api}/payRecord/wxNotify`, params).then(res => res.data);
};

// ==================== 项目合同管理模块 ====================
// 新增/保存项目合同
export const editProjectContract = params => {
  return axios.post(`${api}/projectcontract/edit`, params).then(res => res.data);
};
// 获取项目合同详情
export const getProjectContractDetail = params => {
  return axios.get(`${api}/projectcontract/getDetail/` + params.params.id).then(res => res.data);
};
// 获取项目合同列表
export const getProjectContractList = params => {
  return axios.post(`${api}/projectcontract/getList`, params).then(res => res.data);
};
// 获取项目合同分页列表
export const getProjectContractMePage = params => {
  return axios.post(`${api}/projectcontract/getMePage`, params).then(res => res.data);
};
// 删除项目合同
export const removeProjectContract = params => {
  return axios.get(`${api}/projectcontract/remove/` + params.params.id).then(res => res.data);
};
// 项目合同统计
export const getProjectContractStatistics = params => {
  return axios.post(`${api}/projectcontract/statistics`, params).then(res => res.data);
};

// ==================== 项目订单模块 ====================
// 添加项目订单
export const addProjectOrder = params => {
  return axios.post(`${api}/projectorder/addorder`, params).then(res => res.data);
};
// 新增/保存项目订单
export const editProjectOrder = params => {
  return axios.post(`${api}/projectorder/edit`, params).then(res => res.data);
};
// 获取项目订单详情
export const getProjectOrderDetail = params => {
  return axios.get(`${api}/projectorder/getDetail/` + params.params.id).then(res => res.data);
};
// 获取项目订单列表
export const getProjectOrderList = params => {
  return axios.post(`${api}/projectorder/getList`, params).then(res => res.data);
};
// 获取项目订单分页列表
export const getProjectOrderMePage = params => {
  return axios.post(`${api}/projectorder/getMePage`, params).then(res => res.data);
};
// 项目订单排名
export const getProjectOrderRank = params => {
  return axios.post(`${api}/projectorder/orderRank`, params).then(res => res.data);
};
// 删除项目订单
export const removeProjectOrder = params => {
  return axios.get(`${api}/projectorder/remove/` + params.params.id).then(res => res.data);
};

// ==================== 项目人员模块 ====================
// 新增/保存项目人员
export const editProjectPerson = params => {
  return axios.post(`${api}/projectperson/edit`, params).then(res => res.data);
};
// 获取项目人员详情
export const getProjectPersonDetail = params => {
  return axios.get(`${api}/projectperson/getDetail/` + params.params.id).then(res => res.data);
};
// 获取项目人员列表
export const getProjectPersonList = params => {
  return axios.post(`${api}/projectperson/getList`, params).then(res => res.data);
};
// 获取项目人员分页列表
export const getProjectPersonMePage = params => {
  return axios.post(`${api}/projectperson/getMePage`, params).then(res => res.data);
};
// 删除项目人员
export const removeProjectPerson = params => {
  return axios.get(`${api}/projectperson/remove/` + params.params.id).then(res => res.data);
};

// ==================== 测试模块 ====================
// 权限测试
export const authTest = () => {
  return axios.get(`${api}/test/authTest`).then(res => res.data);
};
// 测试首页
export const testIndex = () => {
  return axios.get(`${api}/test/index`).then(res => res.data);
};
// 403测试
export const testInfo403 = () => {
  return axios.get(`${api}/test/info403`).then(res => res.data);
};
// UUID会话测试
export const uuidSessionTest = params => {
  return axios.get(`${api}/test/uuidSessionTest`, params).then(res => res.data);
};

// ==================== 会员模块扩展 ====================
// 冻结用户
export const freezeUsers = params => {
  return axios.post(`${api}/user/freezes`, params).then(res => res.data);
};
// 获取用户详情
export const getUserDetail = params => {
  return axios.get(`${api}/user/getDetail/` + params.params.id).then(res => res.data);
};
// 获取用户信息
export const getUserInfo = () => {
  return axios.get(`${api}/user/getUserInfo`).then(res => res.data);
};
// 设置用户openid
export const setUserOpenid = params => {
  return axios.post(`${api}/user/setopenid`, params).then(res => res.data);
};
// 上传用户头像
export const uploadUserHeadImg = params => {
  return axios.post(`${api}/user/upload/headImg`, params).then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/view/js/api.js